import React from 'react';
import { SearchByOtherResult } from 'pages/Search/models';
import { SearchByOtherResultTable } from '..';
import { Typography, Row, Col, Divider, Tabs, Icon } from 'antd';
import SearchExport from 'pages/Search/SearchExport/SearchExport';
import { Tabs as TabNames } from 'pages/Search/SearchForm/consts';

const { TabPane } = Tabs;

const { Title } = Typography;

const ResultDocs: React.FC<{ result: SearchByOtherResult }> = (props: {
  result: SearchByOtherResult;
}) => {
  const { result } = props;
  const { searchCriteria } = result;

  return (
    <>
      <Row type="flex" justify="space-between" align="middle">
        <Col>
          <Title level={4}>Search Criteria: {searchCriteria}</Title>
        </Col>

        <SearchExport />
        <Divider dashed />
      </Row>

      {result?.results && result.results.length === 1 ? (
        <SearchByOtherResultTable
          result={result.results[0]}
          tabName={TabNames.Other}
          searchId={result.searchId}
        />
      ) : (
        <Tabs type="card">
          {result.results.map((otherResult, index) => {
            return (
              <TabPane
                tab={
                  <>
                    <Icon type="file" />
                    &nbsp;
                    {otherResult.addressTabTitle}
                  </>
                }
                key={`${index}`}
              >
                <SearchByOtherResultTable
                  result={otherResult}
                  tabName={TabNames.Other}
                  searchId={result.searchId}
                />
              </TabPane>
            );
          })}
        </Tabs>
      )}
    </>
  );
};

export default ResultDocs;
